var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 4.3645H5.83333C4.54417 4.3645 3.5 5.40867 3.5 6.69784V23.0312C3.5 24.3203 4.54417 25.3645 5.83333 25.3645H14.7245V17.2433H11.991V14.0642H14.7245V11.725C14.7245 9.01367 16.3823 7.5355 18.802 7.5355C19.6175 7.53317 20.4318 7.57517 21.2427 7.658V10.493H19.5767C18.2583 10.493 18.0017 11.116 18.0017 12.0353V14.0595H21.1517L20.7422 17.2387H17.983V25.3645H22.1667C23.4558 25.3645 24.5 24.3203 24.5 23.0312V6.69784C24.5 5.40867 23.4558 4.3645 22.1667 4.3645Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFooter);
export default __webpack_public_path__ + "static/media/Facebook_footer.3e20fc6ab9b31f1faee667c672595aa8.svg";
export { ForwardRef as ReactComponent };